const production = {
  apiUrl:
    process.env.VUE_APP_API_URL || "https://need_prod_env_value.example.com",
  recaptchaApikey: "6Ld-BgwTAAAAAGLLsBHy_7WdQA9BHAi6R1ZEA4r-",
  recaptchaValidResponse:
    "03AHJ_VuulQ3Vhnk24UfCfPtOigxVqHWsNjYJI_kn3cSmHC87et17zUa0xhOHyYlLQ3AeN0II2RH5LexR5yztGatPI0LUrg_JaBn4cOOGmxGc31La8aLBHVmD80XVLMA0lNZ-IwzQ8CJaiC6cdAwYzWbNiqDZ4eYy4HDgZlEe1SKnOIA7pC3qXWckTqnXc5XS--Nd5KuVXuUF6F2wROKcScu7qrH66Ci4ih9i3WoYuF7H9_Q2rLUcfUYNtJG-rs9hQBWLK1TXWNMnnVizSfvcgk7jR3lXLbFwRAMdgHt6WcvgLGmz5b5QNaZRb6q6_WoqMzeeoF4ez-BLlu5VmXsGnqut2CRBT8blDaO-vIL5tw8pAqjQ-_yhZC2uf0IUq1dLrnT23X8uONxXdW2rfo4R8Ei7OADxvDbbsYRMCkflEyGzmiBla-Dy5pOD17ShgS2pl5BFjupkorOLNt0CL1kKoyI0l3uu-NkQ5ryzs8jotIPYUySFyeSyByAlJ61Tz4JwWHxWDtiP-2wbsnCHI1IPvgQ8eYO3whHBqmi_FYJwXc1gj0S3B2SUn5gETwBH4GYLt20qKCWX5W7p8OilTmyioTzEPY-mZtrGYFyun8TntpqJtMtDUhEzQ8O5rhEf5oFrL66_xbx11fgXiUhQFjUJ-sRZRGXCUjgSejZKBfbQxBzlVuQcdJKYlr87_fs99yFCmgKZ0qVyMo66l9EraofELvNveXVI66rsF_1661UU5ohxb7GRH7v3k9k_hqL7ynJa8F8NePSuFcpwLOcQQy3Bzi5WQ-c5ExnEAyhAgtCFyqKwcU8pxbf0WkUYdYJ8MePg8hrmGptPG6ZcrQd-oQbGxoH-B_U62kD0txxcPACitrDHM4Jou0kWBeNkWs46V6GsTnoJ_x29X947yJ7vTBFnQFsNE-dUFtQv_Ww",
  releaseStage: "production",
  aadClientId: process.env.VUE_APP_AAD_CLIENT_ID,
  aadAuthority: process.env.VUE_APP_AAD_AUTHORITY,
  aadRedirectUri: "/",
  aadPostLogoutRedirectUri: "/#/sign-in",
  aadTokenScopes: JSON.parse(process.env.VUE_APP_AAD_TOKEN_SCOPES),
};

const staging = {
  apiUrl:
    process.env.VUE_APP_API_URL || "https://need_staging_env_value.example.com",
  recaptchaApikey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
  recaptchaValidResponse:
    "03AHJ_VuulQ3Vhnk24UfCfPtOigxVqHWsNjYJI_kn3cSmHC87et17zUa0xhOHyYlLQ3AeN0II2RH5LexR5yztGatPI0LUrg_JaBn4cOOGmxGc31La8aLBHVmD80XVLMA0lNZ-IwzQ8CJaiC6cdAwYzWbNiqDZ4eYy4HDgZlEe1SKnOIA7pC3qXWckTqnXc5XS--Nd5KuVXuUF6F2wROKcScu7qrH66Ci4ih9i3WoYuF7H9_Q2rLUcfUYNtJG-rs9hQBWLK1TXWNMnnVizSfvcgk7jR3lXLbFwRAMdgHt6WcvgLGmz5b5QNaZRb6q6_WoqMzeeoF4ez-BLlu5VmXsGnqut2CRBT8blDaO-vIL5tw8pAqjQ-_yhZC2uf0IUq1dLrnT23X8uONxXdW2rfo4R8Ei7OADxvDbbsYRMCkflEyGzmiBla-Dy5pOD17ShgS2pl5BFjupkorOLNt0CL1kKoyI0l3uu-NkQ5ryzs8jotIPYUySFyeSyByAlJ61Tz4JwWHxWDtiP-2wbsnCHI1IPvgQ8eYO3whHBqmi_FYJwXc1gj0S3B2SUn5gETwBH4GYLt20qKCWX5W7p8OilTmyioTzEPY-mZtrGYFyun8TntpqJtMtDUhEzQ8O5rhEf5oFrL66_xbx11fgXiUhQFjUJ-sRZRGXCUjgSejZKBfbQxBzlVuQcdJKYlr87_fs99yFCmgKZ0qVyMo66l9EraofELvNveXVI66rsF_1661UU5ohxb7GRH7v3k9k_hqL7ynJa8F8NePSuFcpwLOcQQy3Bzi5WQ-c5ExnEAyhAgtCFyqKwcU8pxbf0WkUYdYJ8MePg8hrmGptPG6ZcrQd-oQbGxoH-B_U62kD0txxcPACitrDHM4Jou0kWBeNkWs46V6GsTnoJ_x29X947yJ7vTBFnQFsNE-dUFtQv_Ww",
  releaseStage: "staging",
  aadClientId:
    process.env.VUE_APP_AAD_CLIENT_ID || "eb8274f3-1ab8-4853-82e2-545d220318f2",
  aadAuthority:
    process.env.VUE_APP_AAD_AUTHORITY ||
    "https://login.microsoftonline.com/16ebcbcc-af3d-49c4-88bc-debc25725f0d",
  aadRedirectUri: "/",
  aadPostLogoutRedirectUri: "/#/sign-in",
  aadTokenScopes: JSON.parse(process.env.VUE_APP_AAD_TOKEN_SCOPES) || [
    "api://eb8274f3-1ab8-4853-82e2-545d220318f2/AWF-Admin",
  ],
};

const development = {
  apiUrl: process.env.VUE_APP_API_URL || "http://localhost:7011",
  recaptchaApikey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
  recaptchaValidResponse:
    "03AHJ_VuulQ3Vhnk24UfCfPtOigxVqHWsNjYJI_kn3cSmHC87et17zUa0xhOHyYlLQ3AeN0II2RH5LexR5yztGatPI0LUrg_JaBn4cOOGmxGc31La8aLBHVmD80XVLMA0lNZ-IwzQ8CJaiC6cdAwYzWbNiqDZ4eYy4HDgZlEe1SKnOIA7pC3qXWckTqnXc5XS--Nd5KuVXuUF6F2wROKcScu7qrH66Ci4ih9i3WoYuF7H9_Q2rLUcfUYNtJG-rs9hQBWLK1TXWNMnnVizSfvcgk7jR3lXLbFwRAMdgHt6WcvgLGmz5b5QNaZRb6q6_WoqMzeeoF4ez-BLlu5VmXsGnqut2CRBT8blDaO-vIL5tw8pAqjQ-_yhZC2uf0IUq1dLrnT23X8uONxXdW2rfo4R8Ei7OADxvDbbsYRMCkflEyGzmiBla-Dy5pOD17ShgS2pl5BFjupkorOLNt0CL1kKoyI0l3uu-NkQ5ryzs8jotIPYUySFyeSyByAlJ61Tz4JwWHxWDtiP-2wbsnCHI1IPvgQ8eYO3whHBqmi_FYJwXc1gj0S3B2SUn5gETwBH4GYLt20qKCWX5W7p8OilTmyioTzEPY-mZtrGYFyun8TntpqJtMtDUhEzQ8O5rhEf5oFrL66_xbx11fgXiUhQFjUJ-sRZRGXCUjgSejZKBfbQxBzlVuQcdJKYlr87_fs99yFCmgKZ0qVyMo66l9EraofELvNveXVI66rsF_1661UU5ohxb7GRH7v3k9k_hqL7ynJa8F8NePSuFcpwLOcQQy3Bzi5WQ-c5ExnEAyhAgtCFyqKwcU8pxbf0WkUYdYJ8MePg8hrmGptPG6ZcrQd-oQbGxoH-B_U62kD0txxcPACitrDHM4Jou0kWBeNkWs46V6GsTnoJ_x29X947yJ7vTBFnQFsNE-dUFtQv_Ww",
  releaseStage: "development",
  aadClientId:
    process.env.VUE_APP_AAD_CLIENT_ID || "eb8274f3-1ab8-4853-82e2-545d220318f2",
  aadAuthority:
    process.env.VUE_APP_AAD_AUTHORITY ||
    "https://login.microsoftonline.com/16ebcbcc-af3d-49c4-88bc-debc25725f0d",
  aadRedirectUri: "/",
  aadPostLogoutRedirectUri: "/#/sign-in",
  aadTokenScopes: JSON.parse(process.env.VUE_APP_AAD_TOKEN_SCOPES) || [
    "api://eb8274f3-1ab8-4853-82e2-545d220318f2/AWF-Admin",
  ],
};

const configs = {
  development,
  production,
  staging,
};

const getConfig = () => {
  const env = process.env.VUE_APP_ENV || "development";
  return configs[env];
};

module.exports = getConfig();
